import { render, staticRenderFns } from "./ReactionListModal.vue?vue&type=template&id=45a9f66e&"
import script from "./ReactionListModal.vue?vue&type=script&lang=js&"
export * from "./ReactionListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports